import { useEffect, useState } from 'react';
import aiContextService from '../service';
import { ALL_QUESTIONS_COUNT } from '../constants';
import { countAnsweredQuestions } from '../utils/progress';

const IDLE_STATE = {
    answeredCount: null,
    totalCount: ALL_QUESTIONS_COUNT,
    ratio: null,
    isLoading: false,
    isError: false,
};

const useAiContextProgress = ({ enabled = true } = {}) => {
    const [state, setState] = useState(enabled ? { ...IDLE_STATE, isLoading: true } : IDLE_STATE);

    useEffect(() => {
        if (!enabled) {
            setState(IDLE_STATE);
            return undefined;
        }

        let cancelled = false;
        setState({ ...IDLE_STATE, isLoading: true });

        aiContextService
            .getContext()
            .then(({ answers }) => {
                if (cancelled) return;
                const answeredCount = countAnsweredQuestions(answers);
                setState({
                    answeredCount,
                    totalCount: ALL_QUESTIONS_COUNT,
                    ratio: ALL_QUESTIONS_COUNT ? answeredCount / ALL_QUESTIONS_COUNT : 0,
                    isLoading: false,
                    isError: false,
                });
            })
            .catch(() => {
                if (!cancelled) setState({ ...IDLE_STATE, isError: true });
            });

        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return state;
};

export default useAiContextProgress;
